export enum PrintProductTypes {
  IMMO_IP_SIGN = 'IP Bord',
  ADHESIVE_SIGN = 'Kleefbord',
  STICKER = 'Sticker',
  ARROW = 'Pijlen',
  VARIA = 'Varia',
}

export enum StickerSubTypes {
  IMMO_WINDOW_STICKER = 'Immo - raamstickers',
  IMMO_STANDARD_STICKER = 'Immo - standaardstickers (verkocht/verhuurd/..)',
  CUSTOM_STICKER = 'Custom',
}

export enum VariaSubTypes {
  UNDERBOARDS = 'Onderborden',
  TOP_SHELVES = 'Bovenborden',
  CONSTRUCTION_SIGNS = 'Werfborden',
  OTHER = 'Andere',
}

export enum MaterialType {
  DUOPROP_4MM = 'Duoprop 4mm',
  X_PRINT_8MM = 'X-print 8mm',
  DIBOND_3MM = 'DIBOND 3mm',
  VINYL_REMOVABLE = 'Vinyl - removable',
  VINYL_PERMANENT = 'Vinyl - permanent',
  VINYL_OPAQUE = 'Vinyl - dekkend',
  VINYL_ONE_WAY = 'Vinyl - one-way',
  OTHER = 'Andere',
}

export enum DimensionType {
  W100_H140 = '100x140',
  W70_H100 = '70x100',
  W50_H140 = '50x140',
  W70_H180 = '70x180',
  W98_H14 = '98x14',
  W60_H12 = '60x12',
  W45_H10 = '45x10',
  W50_H70 = '50x70',
  W35_H50 = '35x50',
  W25_H35 = '25x35',
  W23_H50 = '23x50',
  CUSTOM = 'Custom',
}

export enum PrintMethodType {
  DIGITAL = 'Digitaal',
  SCREENPRINT = 'Zeefdruk',
  SCREENPRINT_DIGITAL = 'Zeefdruk + digitaal',
}

export enum NbColorsType {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  CMYK = 'Full color',
}
